(function () {
const __pewniaki_inline_cfg = JSON.parse(document.currentScript.previousElementSibling.textContent);
(function () {
    var matrixText = __pewniaki_inline_cfg[0];
    var pairBase = __pewniaki_inline_cfg[1], matrixMode = 'count', matrixWindow = __pewniaki_inline_cfg[2];
    function matrixSentence(key,p){return matrixText[key].replace(/\$\{(\w+)\}/g,function(_,n){return String(p[n]);});}
    var A = {
        plik:   '/assets/json/db/' + __pewniaki_inline_cfg[3] + '/analizy/pary.json',
        wersja: __pewniaki_inline_cfg[4],
        lata:   '/assets/json/db/' + __pewniaki_inline_cfg[5] + '/lata/',
        pula:   JSON.parse(String(__pewniaki_inline_cfg[6])),
        typuje: JSON.parse(String(__pewniaki_inline_cfg[7])),
        kod:    __pewniaki_inline_cfg[8],
        // Zakres lat: suma SUROWYCH licznikow par z rocznikow, N = suma losowan.
        // e_pary zostaje null — render liczy je z dane.model.q2.
        sumujLata: function (roczniki) {
            var pary = {}, N = 0;
            roczniki.forEach(function (r) {
                N += r.losowan || 0;
                Object.keys(r.pary || {}).forEach(function (p) { pary[p] = (pary[p] || 0) + r.pary[p]; });
            });
            return { losowan: N, pary: pary, e_pary: null };
        },
        wnioski: function (o, klucz, dane) {
            if (!o || !o.pary) return [matrixText.empty];
            var w = policz(o, dane), p = [];
            var top = w.wszystkie.slice().sort(porownajMalejaco);
            if (top.length && top[0].ile > 0) {
                p.push(matrixSentence('top',{a:top[0].a,b:top[0].b,count:tys(top[0].ile),n:tys(w.N),model:w.e!=null?matrixSentence('model',{expected:f1(w.e)}):''}));
            }
            p.push(matrixSentence('zero',{zero:tys(w.bez),all:tys(w.cm2),model:w.bezModel!=null?matrixSentence('zeroModel',{n:tys(w.N),expected:f1(w.bezModel)}):''}));
            if (w.e != null) {
                p.push(w.e >= 5
                    ? matrixSentence('spread',{all:tys(w.cm2),tail:tys(Math.round(w.cm2*0.02275))})
                    : matrixSentence('low',{expected:f1(w.e)}));
            }
            return p.length ? p : [matrixText.empty];
        },
        render: function (okno, klucz, dane, zakres) {
            var q = function (s) { return document.querySelector(s); };
            var sekcja = q('[data-pary]');
            if (!okno || !okno.pary) {
                if (sekcja) { sekcja.hidden = true; }
                ['n', 'e', 'bez', 'bez-model'].forEach(function (nazwa) { var el = q('[data-pary-' + nazwa + ']'); if (el) { el.textContent = '—'; } });
                return;
            }
            if (sekcja) { sekcja.hidden = false; }
            var w = policz(okno, dane);
            matrixWindow = klucz;
            q('[data-pary-n]').textContent = tys(w.N);
            q('[data-pary-cm2]').textContent = tys(w.cm2);
            q('[data-pary-e]').textContent = f1(w.e);
            q('[data-pary-bez]').textContent = tys(w.bez);
            q('[data-pary-bez-model]').textContent = f1(w.bezModel);
            var top = w.wszystkie.slice().sort(porownajMalejaco).slice(0, 20);
            var dol = w.wszystkie.slice().sort(function (x, y) { return x.ile - y.ile || x.a - y.a || x.b - y.b; }).slice(0, 10);
            q('[data-pary-top] tbody').innerHTML = top.map(function (p) { return wiersz(p, w.e); }).join('');
            q('[data-pary-dol] tbody').innerHTML = dol.map(function (p) { return wiersz(p, w.e); }).join('');
            q('[data-pary-norma]').textContent = w.e == null
                ? matrixText.normMissing
                : (w.e >= 5
                    ? matrixSentence('normSpread',{all:tys(w.cm2),tail:tys(Math.round(w.cm2*0.02275))})
                    : matrixSentence('normLow',{expected:f1(w.e)}));
            renderMatrix(w, zakres);
        }
    };

    var en = /^en(?:-|$)/i.test(document.documentElement.lang || '');
    var tys = function (v) { return v == null ? '—' : String(v).replace(/\B(?=(\d{3})+(?!\d))/g, ' '); };
    // Zawsze jedno miejsce po przecinku i separator tysiecy — jak number_format(1, constant('CURRENT_LANG') == 'en' ? '.' : ',', constant('CURRENT_LANG') == 'en' ? ',' : ' ') w Twigu.
    var f1 = function (v) {
        if (v == null) return '—';
        var s = Math.abs(v).toFixed(1).split('.');
        return (v < 0 ? '-' : '') + tys(s[0]) + (en ? '.' : ',') + s[1];
    };
    var porownajMalejaco = function (x, y) { return y.ile - x.ile || x.a - y.a || x.b - y.b; };
    var kula = function (n) { return __pewniaki_inline_cfg[9] + A.kod + '">' + n + '</span>'; };
    var wiersz = function (p, e) {
        var odch = e != null && e > 0 ? (p.ile - e) / Math.sqrt(e) : null;
        // Sortowanie kolumny PARA: klucz 003026 (a, potem b). Bez niego main.js
        // czytal sklejone cyfry z kul ("2679") i kolejnosc byla przypadkowa. (22.09.2026)
        var klucz = String(p.a).padStart(3, '0') + String(p.b).padStart(3, '0');
        return __pewniaki_inline_cfg[10] + klucz + '"><span class="kule kule--inline">' + kula(p.a) + kula(p.b) + '</span></td>'
            + '<td class="liczbowa">' + tys(p.ile) + '</td><td class="liczbowa">' + f1(e) + '</td>'
            + '<td class="liczbowa">' + (odch == null ? '—' : (odch > 0 ? '+' : '') + f1(odch)) + '</td></tr>';
    };
    // Pelna lista C(m,2) par z licznikiem — brak klucza w mapie to prawdziwe zero wystapien.
    var policz = function (okno, dane) {
        var m = dane.pula || A.pula, N = okno.losowan || 0, mapa = okno.pary || {};
        var q2 = dane.model && dane.model.q2 != null ? dane.model.q2 : null;
        var e = okno.e_pary != null ? okno.e_pary : (q2 != null && N > 0 ? N * q2 : null);
        var wszystkie = [], niezerowe = 0;
        for (var a = 1; a < m; a++) {
            for (var b = a + 1; b <= m; b++) {
                var ile = mapa[a + '-' + b] || 0;
                if (ile > 0) { niezerowe++; }
                wszystkie.push({ a: a, b: b, ile: ile });
            }
        }
        var cm2 = m * (m - 1) / 2;
        return { m: m, N: N, e: e, cm2: cm2, wszystkie: wszystkie, bez: cm2 - niezerowe,
                 bezModel: q2 != null && N > 0 ? cm2 * Math.pow(1 - q2, N) : null };
    };

    var matrixParams = function(a,b,zakres){var p=new URLSearchParams({a:String(a),b:String(b)});if(zakres&&zakres.od&&zakres.do){p.set('od',zakres.od);p.set('do',zakres.do);}else if(matrixWindow){p.set('okno',matrixWindow);}return p.toString();};
    var colorMatrix = function(){
        var cells=Array.from(document.querySelectorAll('[data-pair-cell]'));
        var max=cells.reduce(function(m,cell){var v=matrixMode==='diff'?Math.abs(Number(cell.dataset.diff)||0):Number(cell.dataset.count)||0;return Math.max(m,v);},0);
        cells.forEach(function(cell){
            var raw=matrixMode==='diff'?Number(cell.dataset.diff)||0:Number(cell.dataset.count)||0, ratio=max>0?Math.abs(raw)/max:0, alpha=(0.08+ratio*0.82).toFixed(3);
            var rgb=matrixMode==='diff'&&raw>0?'249,115,22':'0,102,255';
            Array.from(cell.classList).filter(function(c){return c.indexOf('udzial--')===0;}).forEach(function(c){cell.classList.remove(c);});
            cell.classList.add('pary-komorka','udzial--'+Math.round(Number(alpha)*100));
            cell.classList.toggle('pary-komorka--plus',matrixMode==='diff'&&raw>0);
            cell.classList.toggle('pary-komorka--jasna',ratio>0.55);
        });
    };
    var renderMatrix = function(w,zakres){
        var body=document.querySelector('[data-pairs-matrix] tbody');if(!body)return;
        var byKey={};w.wszystkie.forEach(function(p){byKey[p.a+'-'+p.b]=p;});var rows=[];
        for(var a=1;a<=w.m;a++){var cells=['<tr><th scope="row" class="liczbowa styl-297f4dcf49" >'+a+'</th>'];for(var b=1;b<=w.m;b++){
            if(b<=a){cells.push('<td class="styl-297f4dcf49" aria-hidden="true" >·</td>');continue;}var p=byKey[a+'-'+b],diff=w.e==null?null:p.ile-w.e,val=matrixMode==='diff'?(diff==null?'—':(diff>0?'+':'')+f1(diff)):tys(p.ile),label=matrixMode==='diff'?matrixSentence('diff',{a:a,b:b,diff:val}):matrixSentence('count',{a:a,b:b,count:p.ile});
            cells.push(__pewniaki_inline_cfg[11]+p.ile+'" data-diff="'+(diff==null?'':diff)+'" href="'+pairBase+'?'+matrixParams(a,b,zakres)+'" aria-label="'+label.replace(/&/g,'&amp;').replace(/"/g,'&quot;')+'">'+val+'</a></td>');
        }rows.push(cells.join('')+'</tr>');}body.innerHTML=rows.join('');colorMatrix();
    };
    document.querySelectorAll('[data-pairs-mode]').forEach(function(button){button.addEventListener('click',function(){matrixMode=button.dataset.pairsMode;document.querySelectorAll('[data-pairs-mode]').forEach(function(b){var on=b===button;b.setAttribute('aria-pressed',on?'true':'false');b.classList.toggle('przycisk--glowny',on);});var cells=document.querySelectorAll('[data-pair-cell]');cells.forEach(function(cell){var a=cell.closest('tr').rowIndex,b=cell.closest('td').cellIndex,d=Number(cell.dataset.diff),value=matrixMode==='diff'?(cell.dataset.diff===''?'—':(d>0?'+':'')+f1(d)):tys(Number(cell.dataset.count));cell.textContent=value;cell.setAttribute('aria-label',matrixMode==='diff'?matrixSentence('diff',{a:a,b:b,diff:value}):matrixSentence('count',{a:a,b:b,count:cell.dataset.count}));});colorMatrix();});});
    colorMatrix();

    window.PEWNIAKI_ANALIZA = A;
})();
})();
